import { observer } from "mobx-react-lite";
import React from "react";
import { BtnOutlineV4 } from "../../UI/button/BtnOutlineV4";

export const ItemClientIdAdmin = observer(({ clientid, deleteClient, gridClass }) => {
  if (!clientid.software_client_rel) {
    return null;
  }

  return (
    <div className={`cc-v4-soft-row ${gridClass}`}>
      <span className="admin-users-cell company-card-v4-mono">
        {clientid.client_id}
      </span>
      <span className="admin-users-cell">
        {clientid.software_client_rel.name}
      </span>
      <span className="admin-users-cell">
        {clientid.company_rel.name_company}
      </span>
      <div className="admin-client-id-action-cell">
        <BtnOutlineV4
          text="Отвязать"
          onClick={() => deleteClient(clientid)}
        />
      </div>
    </div>
  );
});
